import "@/instrument.js";
import "flowbite";
import "./assets/index.scss";
import { router } from "./routes/index.jsx"; // routes
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import {
  focusManager,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

// React Query v5 only listens to "visibilitychange" by default, so alt-tabbing
// between OS windows doesn't trigger refetchOnWindowFocus. Restore the v4
// behavior by also listening to the window "focus" event.

focusManager.setEventListener((handleFocus) => {
  const onVisibilityChange = () => handleFocus();
  const onFocus = () => handleFocus();
  window.addEventListener("visibilitychange", onVisibilityChange);
  window.addEventListener("focus", onFocus);
  return () => {
    window.removeEventListener("visibilitychange", onVisibilityChange);
    window.removeEventListener("focus", onFocus);
  };
});

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById("root")).render(
  <QueryClientProvider client={queryClient}>
    <RouterProvider router={router} />
    <ReactQueryDevtools position="top-right" initialIsOpen={false} />
  </QueryClientProvider>,
);
